<template>
    <wrapper-features-templates-one-column
    hideClose
    centerLogo
    fullWhiteBox
    nonAuthenticatedFeature>
        <!-- Loader Generic -->
		<loaders-generic v-if="showLoader || showOverlayLoader" :isOverlay="showOverlayLoader"/>
        <!-- Component -->
        <div
        v-if="!showSpinner"
        class="information-container"
        :class="{ 'mobile': getMobileAppState, 'center-content': componentName !== 'AuthenticateSessionInfo' }">
            <component
            :is="activeComponent"
            :isMobileApp="getMobileAppState"
            :sessionInfo="sessionInfo"
            @authorizeSession="authorizeSessionHandler"
            @cancelSession="cancelSessionHandler"/>
        </div>
    </wrapper-features-templates-one-column>
</template>

<script setup>
import WrapperFeaturesTemplatesOneColumn from '@/components/wrappers/featuresTemplates/OneColumn'
import LoadersGeneric from '@/components/generic/loaders/Generic'

/* Vue */
import { ref, computed, defineAsyncComponent } from 'vue'

/* Store */
import { mapActions, mapGetters } from '@/store/helpers/mappers'
import { moduleMapper } from '@/store/helpers/modules.map'

/* mapActions & mapGetters */
const { getOutofbandRequestDetail, validateRefuseOutofbandValidationRequest } = mapActions(moduleMapper.SESSION)
const { getMobileAppState } = mapGetters()

const props = defineProps({
    processId: [String, Number]
})

const showSpinner = ref(false)
const showOverlaySpinner = ref(false)
const componentName = ref('AuthenticateSessionInfo')
const sessionInfo = ref({})

const activeComponent = computed(() => {
    const name = componentName.value
    return defineAsyncComponent(() => import('@/components/features/nonAuthenticated/authenticatedSession/' + name))
})

const fetchSessionInfo = async () => {
    showSpinner.value = true

    try {
		const response = await getOutofbandRequestDetail(props.processId)
		showSpinner.value = false
        sessionInfo.value = response.data.data
	} catch (error) {
		if (error.response && error.response.status === 401) return
        errorHandler()
	}
}

const authorizeSessionHandler = async () => {
    showOverlaySpinner.value = true

    const payload = {
        processId: props.processId,
        valid: true
    }

    try {
        await validateRefuseOutofbandValidationRequest(payload)
		showOverlaySpinner.value = false
        componentName.value = 'AuthorizedSession'
	} catch (error) {
        if (error.response && error.response.status === 401) return
        errorHandler()
	}
}

const cancelSessionHandler = async () => {
    showOverlaySpinner.value = true

    const payload = {
        processId: props.processId,
        valid: false
    }

    try {
        await validateRefuseOutofbandValidationRequest(payload)
		showOverlaySpinner.value = false
        componentName.value = 'CanceledSession'
	} catch (error) {
		if (error.response && error.response.status === 401) return
        errorHandler()
	}
}

const errorHandler = () => {
    showSpinner.value = false
    showOverlaySpinner.value = false
    componentName.value = 'TimeOutSession'
}

fetchSessionInfo()
</script>

<style lang="scss" scoped>
.information-container {
    width: 100%;
    max-width: 508px;
    margin: 0 auto;

    display: flex;
    flex-direction: column;

    &.center-content {
        height: 100%;
        justify-content: center;
    }
}
</style>
